// Copyright Epic Games, Inc. All Rights Reserved.
import type { FC, ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { MDXRemoteSerializeResult } from 'next-mdx-remote';

import type { PartialsMap } from '@models/Partial';
import type { TableOfContentsMap } from '@models/Toc';

export type ProtectedContentValue = {
  pageSource: MDXRemoteSerializeResult;
  partialsSources: PartialsMap;
  tableOfContentsMap: TableOfContentsMap;
  timeToRead: number;
} | null;

export const ProtectedContentContext = createContext<ProtectedContentValue>(null);

export const useProtectedContent = () => useContext(ProtectedContentContext);

interface ProtectedContentProviderProps {
  value: ProtectedContentValue;
  children?: ReactNode;
}

export const ProtectedContentProvider: FC<ProtectedContentProviderProps> = ({ value, children }) => (
  <ProtectedContentContext.Provider value={value}>{children}</ProtectedContentContext.Provider>
);
